import React from 'react';

export const Registration = () => {
  return (
    <div>
      <h1>this is the Registration page</h1>
    </div>
  );
};
